var map = {
	"./Arctico Gloss.jpg": "UY6j",
	"./Arctico Matts.jpg": "LmPC",
	"./Cafe Noir.jpg": "yPb0",
	"./Cannoli.jpg": "rxAH",
	"./Caraway.jpg": "zBOJ",
	"./Chia Seed.jpg": "ChZB",
	"./Chocolate.jpg": "baz9",
	"./Coconut.jpg": "k4nL",
	"./Coffee Bean.jpg": "lsOw",
	"./Earl Grey.jpg": "4igc",
	"./Latitude East.jpg": "y/0n",
	"./Macadamia.jpg": "2LrS",
	"./Maple Espresso.jpg": "+oXu",
	"./Maple Oregano.jpg": "5yiD",
	"./Maple Oyster.jpg": "7q3c",
	"./Maple Porcini.jpg": "G8MW",
	"./Maple Shale Grey.jpg": "EOWL",
	"./Maple Soapstone.jpg": "H364",
	"./Meringue.jpg": "M24X",
	"./Oak Chocolate.jpg": "UEoc",
	"./Oak Oregano.jpg": "X20n",
	"./Oak Oyster.jpg": "01MT",
	"./Oak Porcini.jpg": "Posa",
	"./Oak Shale Grey.jpg": "0j0q",
	"./Ontario White.jpg": "MCyQ",
	"./Oregano.jpg": "WnP+",
	"./Oyster.jpg": "xdug",
	"./Poppy Seed.jpg": "lgBl",
	"./Porcini.jpg": "FhPt",
	"./RUEDA GLOSS.jpg": "zV4q",
	"./Rueda Matte.jpg": "OtLq",
	"./Shale Grey.jpg": "nehH",
	"./Soapstone.jpg": "P2Dl",
	"./Spring Blossom.jpg": "jmvZ",
	"./Stainless.jpg": "OBsQ",
	"./TORMENTA GLOSS.jpg": "O+pu",
	"./Tormenta Matte.jpg": "rqdq",
	"./White Sugar.jpg": "9Mty",
	"./Winter White.jpg": "oigS",
	"./oak poppy seed.jpg": "vKZ8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ARIe";


//////////////////
// WEBPACK FOOTER
// ./static/img/color ^\.\/.*\.jpg$
// module id = ARIe
// module chunks = 0